const FaqData = (data) => {
  const faqData = data.allFaqs.nodes;
  const faqObjects = faqData.reduce(
    (acc, curr) => {
      if (!acc[curr.category]) acc[curr.category] = [];
      acc[curr.category].push(curr);
      return acc;
    },
    { General: [] },
  );

  let faqObjectAmended = {};
  let faqArray = [];
  for (const [key, value] of Object.entries(faqObjects)) {
    if (key === 'General') {
      let newValue = faqObjects.General.concat(faqObjects.null);
      faqObjectAmended = {
        title: 'General',
        dropdownQuestions: newValue,
      };
    } else if (key === 'null') {
      null;
    } else {
      faqObjectAmended = {
        title: key,
        dropdownQuestions: value,
      };
    }

    if (!faqArray.includes(faqObjectAmended)) {
      faqArray.push(faqObjectAmended);
    }
  }
  let faqsDropdownData = faqArray;

  return faqsDropdownData;
};

export default FaqData;
